@import 'styles/mixins';
@import 'styles/blaze/mixins';

.xLoadingPreview {
  border-radius: 20px;
  border: 1px solid var(--dark-8);
  background: var(--light-100);
  box-shadow: 0px 20px 80px 0px var(--dark-10);
  display: flex;
  flex-direction: column;
  max-width: 630px;
  min-height: 413px;

  .header {
    margin-bottom: 20px;
    padding: 14px 18px 0 18px;

    :global .ant-skeleton {
      .ant-skeleton-paragraph {
        display: flex;
        flex-direction: column;
        gap: 4px;
        padding-top: 4px;

        li:first-child {
          border-radius: 90px;
          margin-top: 0 !important;
          height: 14px;
          width: 150px;
        }

        li:nth-child(2) {
          border-radius: 90px;
          margin-top: 4px !important;
          height: 12px;
          width: 450px;
        }

        li:last-child {
          border-radius: 90px;
          margin-top: 4px !important;
          height: 12px;
          width: 380px !important;
        }
      }
    }
  }

  .text {
    margin-bottom: 20px;
    padding: 0 16px;

    :global .ant-skeleton {
      .ant-skeleton-paragraph {
        display: flex;
        flex-direction: column;
        gap: 12px;

        li {
          border-radius: 90px;
          margin-top: 0 !important;
          height: 10px;
        }

        li:last-child {
          width: 450px !important;
        }
      }
    }
  }

  .body {
    @include blur(5px);
    height: 100%;
    opacity: 0.4;
    background: linear-gradient(180deg, var(--light-100) 0%, var(--brand-kit-color) 100%);
  }

  .footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px;
    width: 100%;

    :global .ant-skeleton-header {
      padding-right: 6px !important;
    }

    :global .ant-skeleton.ant-skeleton-with-avatar.ant-skeleton-active {
      width: 60px !important;
    }

    :global .ant-skeleton-paragraph {
      width: 32px !important;
    }

    :global .ant-skeleton-with-avatar {
      width: 100px;

      .ant-skeleton-content {
        .ant-skeleton-paragraph li {
          border-radius: 90px;
          margin-top: 4px !important;
        }
      }
    }
  }
}
